import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import {
  GetQUestionParams,
  GetQUestionParamsInQuestionBank,
  options,
  TikZType,
} from 'src/app/constants/constants';
import { GlobalApiService } from 'src/app/services/global-api.service';
import {
  QuestionBankFilter,
  QuestionBankService,
} from './question-bank.service';
import { Subscription } from 'rxjs';
import { questionCategories } from '../create-question/create-question.constant';

declare var update: any;

@Component({
  selector: 'app-question-bank',
  templateUrl: './question-bank.component.html',
  styleUrls: ['./question-bank.component.scss'],
})
export class QuestionBankComponent implements OnInit, OnDestroy {
  courses: any[] = [];
  selectedCourseIndex: number | null = null;
  sections: any[] = [];
  selectedSectionIndex: number | null = null;
  courseClicked: boolean = false;
  difficultyLevels: any[] = [];
  selectedLevel: number | null = 0;
  topics: any[] = [];
  selectedTopic: any = null;
  selectedSubTopic: any = null;
  subTopics: any[] = [];
  questions: any[] = [];
  optionsText: string[] = options;
  selectedQuestionType: number | null = null;
  tags: any[] = [];
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  private readonly notifier: NotifierService;
  questionBankFilters: QuestionBankFilter | undefined;
  questionBankSubscription: Subscription;
  isDataLoading: boolean = true;
  images: any = {};
  questionCategories = questionCategories;
  selectedQuestionCategory: number = 0;
  constructor(
    private globalApiService: GlobalApiService,
    private router: Router,
    notifierService: NotifierService,
    private questionBankService: QuestionBankService
  ) {
    this.notifier = notifierService;
    this.questionBankSubscription = this.questionBankService
      .getQuestionBankFilters()
      .subscribe((filter: QuestionBankFilter) => {
        console.log(filter);
        this.questionBankFilters = filter;
      });
  }
  ngOnInit(): void {
    this.isDataLoading = true;
    this.selectedQuestionType = this.questionBankFilters?.questionType || 0;
    this.globalApiService.getTestTypes().subscribe(
      (response: any) => {
        console.log(response);
        this.courses = response;
        if (this.questionBankFilters?.courseId !== null) {
          for (const [index, course] of this.courses.entries()) {
            console.log(index, course);
            if (course.testTypeId === this.questionBankFilters?.courseId) {
              this.selectedCourseIndex = index;
              this.selectCourse();
              break;
            }
          }
        } else {
          this.isDataLoading = false;
        }
      },
      (error) => {
        this.notifier.notify('error', 'Unable to fetch test types');
      }
    );
    this.getDifficultyLevels();
  }

  selectCourse(): void {
    this.selectedSectionIndex = null;
    this.selectedTopic = null;
    this.selectedSubTopic = null;
    this.sections = [];
    this.topics = [];
    this.subTopics = [];
    this.questions = [];
    this.getSections();
  }

  selectSection(): void {
    this.selectedTopic = null;
    this.selectedSubTopic = null;
    this.questions = [];
    this.topics = [];
    this.subTopics = [];
    this.getTopicsAndSubTopics();
  }

  selectTopic(event: any): void {
    this.selectedSubTopic = null;
    this.subTopics = this.topics[this.selectedTopic].subtopics;
  }

  goToCreateQuestion(): void {
    this.questionBankService.setQuestionBankFilters({
      courseId:
        this.selectedCourseIndex !== null
          ? this.courses[this.selectedCourseIndex].testTypeId
          : null,
      sectionId:
        this.selectedSectionIndex !== null
          ? this.sections[this.selectedSectionIndex].test_section_type_id
          : null,
      topicId:
        this.selectedTopic !== null
          ? this.topics[this.selectedTopic].topic_id
          : null,
      subTopicId:
        this.selectedSubTopic !== null
          ? this.subTopics[this.selectedSubTopic].subtopic_id
          : null,
      difficultyLevel: this.selectedLevel,
      questionType: this.selectedQuestionType,
    });
    this.router.navigateByUrl(`/create-question`);
  }

  goToQuestion(questionId: number): void {
    const url = `/edit-question?question_id=${questionId}`;
    console.log(url);
    this.router.navigateByUrl(url);
  }

  getSections(): void {
    this.globalApiService
      .getSectionsByTestTypeId(
        this.courses[this.selectedCourseIndex!].testTypeId
      )
      .subscribe(
        (response: any) => {
          this.courseClicked = false;
          console.log(response);
          const data = JSON.parse(response.data);
          console.log(data);
          this.sections = data;
          if (
            this.questionBankFilters?.sectionId !== null &&
            this.isDataLoading
          ) {
            for (const [index, section] of this.sections.entries()) {
              if (
                section.test_section_type_id ===
                this.questionBankFilters?.sectionId
              ) {
                this.selectedSectionIndex = index;
                this.selectSection();

                break;
              }
            }
          } else {
            this.isDataLoading = false;
          }
        },
        (error: any) => {
          this.courseClicked = false;
          this.notifier.notify('error', 'Unable to fetch section types');
        }
      );
  }

  getDifficultyLevels() {
    this.globalApiService.getDifficultyLevels().subscribe(
      (response: any) => {
        this.difficultyLevels = response;
        console.log(this.difficultyLevels);
        // this.selectedLevel = this.difficultyLevels[0].tdlId;
        if (this.questionBankFilters?.difficultyLevel !== null) {
          for (const level of this.difficultyLevels) {
            if (level.tdlId === this.questionBankFilters?.difficultyLevel) {
              this.selectedLevel = level.tdlId;
              break;
            }
          }
        }
      },
      (error) => {
        this.notifier.notify('error', 'Unable to fetch difficulty levels');
      }
    );
  }

  getTopicsAndSubTopics() {
    this.globalApiService
      .getTopicsAndSubTopicsByTestSection(
        this.sections[this.selectedSectionIndex!].test_section_type_id
      )
      .subscribe(
        (response: any) => {
          console.log(JSON.parse(response.data));
          this.isDataLoading = false;
          this.topics = JSON.parse(response.data)['result'];
          if (this.questionBankFilters?.topicId !== null) {
            for (const [index, topic] of this.topics.entries()) {
              if (topic.topic_id === this.questionBankFilters?.topicId) {
                this.selectedTopic = index;
                this.subTopics = this.topics[index].subtopics;
                for (const [
                  subTopicIndex,
                  subTopic,
                ] of this.subTopics.entries()) {
                  if (
                    subTopic.subtopic_id ===
                    this.questionBankFilters?.subTopicId
                  ) {
                    this.selectedSubTopic = subTopicIndex;
                    this.getQuestions();
                    break;
                  }
                }
                break;
              }
            }
          }
        },
        (error: any) => {
          this.notifier.notify('error', 'Unable to fetch topics');
        }
      );
  }

  getQuestions() {
    if (this.selectedSubTopic !== null) {
      console.log('Loading get questions');
      const params: GetQUestionParamsInQuestionBank = {
        topicId: this.topics[this.selectedTopic].topic_id,
        subTopicId: this.subTopics[this.selectedSubTopic].subtopic_id,
        difficultyLevel: this.selectedLevel,
        questionType: this.selectedQuestionType,
        pageNo: 1,
        tags: this.tags.toString(),
        questionCategories: this.selectedQuestionCategory,
      };
      this.globalApiService
        .getQuestionsWithParamsInQuestionBank(params)
        .subscribe(
          (response: any) => {
            console.log(response);
            this.questions = response.questions || [];
            this.loadImages();
            this.loadTikZ();
          },
          (error: any) => {
            console.log(error);
            this.notifier.notify('error', 'Unable to load Questions');
          }
        );
    }
  }

  /* TikZ loading code */
  loadTikZ() {
    const totaltikZ: TikZType[] = [];
    this.questions.forEach((qData: any, qIndex: number) => {
      const questions = qData.question.questionData;
      for (let i = 0; i < questions.length; i++) {
        const question = questions[i];
        if (question.type === 'TikZ') {
          totaltikZ.push({
            id: 'tikzOutput-' + qIndex + '-' + i,
            data: question.data,
          });
        }
      }
      console.log(totaltikZ);
      console.log(qData);
      if (qData.question.questionType === 1) {
        const options = qData.choices;
        for (let i = 0; i < options.length; i++) {
          const option = options[i];
          for (let j = 0; j < option.optionValue.length; j++) {
            const optionItem = option.optionValue[j];
            if (optionItem.type === 'TikZ') {
              console.log('question tikz -> ', optionItem.data);
              totaltikZ.push({
                id: 'tikzOutput-option-' + qIndex + '-' + i + '-' + j,
                data: optionItem.data,
              });
            }
          }
          // ** LOad tikz for Explanations
          console.log(option);
          const explanations: any[] = option.explanation || [];
          explanations.forEach((explanation, explanationIndex) => {
            if (explanation.type === 'TikZ') {
              console.log(explanation);
              console.log('exp tikz -> ', explanation.data);
              totaltikZ.push({
                id:
                  'tikzOutput-option-' +
                  qIndex +
                  '-' +
                  i +
                  '-' +
                  explanationIndex +
                  '-' +
                  explanationIndex,
                data: explanation.data,
              });
            }
          });
        }
      } else {
        qData.answers?.explanation?.forEach(
          (explanation: any, explanationIndex: number) => {
            if (explanation.type === 'TikZ') {
              console.log(explanation);
              console.log('exp tikz -> ', explanation.data);
              totaltikZ.push({
                id:
                  'tikzOutput-freeTextExplanation-' +
                  qIndex +
                  '-' +
                  explanationIndex +
                  '-' +
                  explanationIndex,
                data: explanation.data,
              });
            }
          }
        );
      }
    });
    console.log(totaltikZ);
    if (totaltikZ.length > 0) {
      this.delayTikz(0, totaltikZ);
    }
  }

  loadImages() {
    const listOfImages: string[] = [];
    this.questions.forEach((questionItem: any) => {
      const questionData = questionItem.question.questionData;
      questionData.forEach((question: any, questionIndex: number) => {
        if (question['type'] === 'Images') {
          question['images'] = JSON.parse(question['data']) || [];
          listOfImages.push(...question['images']);
        }
      });
      if (questionItem.question.questionType === 1) {
        questionItem.choices.forEach((choice: any, index: number) => {
          const optionValue: any[] = choice.optionValue || [];
          optionValue.forEach((option, optionIndex) => {
            if (option['type'] === 'Images') {
              option['images'] = JSON.parse(option['data']) || [];
              listOfImages.push(...option['images']);
            }
          });
          const explanations: any[] = choice.explanation || [];
          explanations.forEach((explanation, explanationIndex) => {
            if (explanation['type'] === 'Images') {
              explanation['images'] = JSON.parse(explanation['data']) || [];
              listOfImages.push(...explanation['images']);
            }
          });
        });
      } else if (questionItem.question.questionType === 2) {
        const explanations: any[] = questionItem.answers.explanation || [];
        explanations.forEach((explanation, explanationIndex) => {
          if (explanation['type'] === 'Images') {
            explanation['images'] = JSON.parse(explanation['data']) || [];
            listOfImages.push(...explanation['images']);
          }
        });
      }
    });
    this.getImages(listOfImages);
  }

  getImages(listOfImages: string[]) {
    this.globalApiService.getImages(listOfImages).subscribe(
      (response: any) => {
        console.log(response);
        const data = response.data;
        if (data) {
          this.images = { ...this.images, ...data };
        }
        console.log(this.images);
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  getExplanationParentArray(questionType: number, question: any): any[] {
    // TODO: uncomment
    // console.log(question);
    let explanationArray: any[] =
      questionType === 1 ? question.choices : question.answers.explanation;
    // TODO: uncomment
    // console.log(questionType === 1, explanationArray);
    return explanationArray;
  }

  isExplanationExists(questionType: number, option: any): boolean {
    let explanationExists: boolean =
      questionType === 1 ? !option.explanation : option.length > 0;
    return explanationExists;
  }

  getExplanationArray(questionType: number, question: any, option: any): any[] {
    let explanationArray: any[] =
      questionType === 1 ? option.explanation : question.answers.explanation;
    // TODO: uncomment
    // console.log(questionType === 1, explanationArray);
    return explanationArray;
  }

  delayTikz(index: number, totaltikZ: TikZType[]) {
    setTimeout(() => {
      console.log(index, totaltikZ[index]);
      new update(totaltikZ[index].data, totaltikZ[index].id);
      index++;
      if (index < totaltikZ.length) {
        this.delayTikz(index, totaltikZ);
      }
    }, 500);
  }

  addTag(event: any): void {
    const input = event.input;
    const value = event.value;

    // Add our tag
    if ((value || '').trim()) {
      this.tags.push(value.trim());
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.getQuestions();
  }

  removeTag(index: number): void {
    this.tags.splice(index, 1);
    this.getQuestions();
  }

  ngOnDestroy(): void {
    this.questionBankSubscription.unsubscribe();
  }
}
